<template>
    <b-container fluid class="animated fadeIn">
        <h1>Incluir / Alterar Parâmetros GR</h1>
        <b-card>
             <b-row>
                <b-col xs="12" sm="12" md="9" lg="9" xl="9">
                    <b-form-group label="Texto GR protesto: *" label-for="textoGrprotesto" >
                        <vue-editor id="textoGrprotesto"  v-model="parametros.txtgrprotesto" :style="{ height: '200px', overflowY: 'auto', border: '1px solid #ddd', padding: '0px' }" ></vue-editor>
                    </b-form-group>

                </b-col>
            </b-row>

             <b-row>
                <b-col xs="12" sm="12" md="9" lg="9" xl="9">
                    <b-form-group label="Texto GR Ajuizamento: *" label-for="textoGrAjuizamento" >
                        <vue-editor id="textoGrAjuizamento"  v-model="parametros.txtgrajuizamento" :style="{ height: '200px', overflowY: 'auto', border: '1px solid #ddd', padding: '0px' }"></vue-editor>
                    </b-form-group>

                </b-col>
            </b-row>

      
             <b-row>
                <b-col xs="12" sm="12" md="9" lg="9" xl="9">
                    <b-form-group label="Texto GR Protesto Ajuizamento: *" label-for="textoGrProtestoAjuizamento2" >
                        <vue-editor id="textoGrProtestoAjuizamento2" v-model="parametros.txtgrprotestoajuizamento" :style="{ height: '200px', overflowY: 'auto', border: '1px solid #ddd', padding: '0px' }"> </vue-editor>

                    </b-form-group>

                </b-col>
            </b-row>
            <b-row>
                <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                    <b-button variant="primary" @click="salvar">
                        <i class="fa fa-save"></i> Salvar
                    </b-button>
                    <b-button variant="primary" class="ml-2" @click="voltar">
                        <i class="fa fa-reply"></i> Voltar
                    </b-button>
                </b-col>
            </b-row>
        </b-card>

    </b-container>

</template>

<script>

import axios from 'axios'
import { VueEditor } from 'vue2-quill-editor'

export default {
    
    name: 'ParametrosGr',
    components: {
        VueEditor
    },
    data() {
        return {        
            parametros: { 
                txtgrprotesto: null,
                txtgrajuizamento:null,
                txtgrprotestoajuizamento: null,

                //listados apenas para serem devolvidos novamente.
                codParametro: null,
                diasFechadoFimMes: null,
                qtdSimultaneaConsultaDae: null,
                emailCoordenador: null,
                procuradorGeral: null,
                telefoneorgao: null,
                qtdThreadsObterCdas: null,
                nomeOrgao: null,
                cnpjOrgao: null,
                enderecoOrgao: null,
                municipioOrgao: null,
                qtdObterCdaPdf: null,
                tempoExecucacaoEnviarProcessoTJ: null,
                tempoExecucacaoIncluirSPJ: null,
                qtdThreadsEnviarProcessoTJ: null,
                tempoAtualizacaoPagina: null,
                qtdCdaProcesso: null,
                prazoRetornoDiaSEPA: null,
                qtdeRetornoCDAnaoDistribuidas: null,
                emailCra: null,
                qtdThreadSelecaoProtesto: null,
                dataLimiteProtesto: null,
                qtdeReferenciaQuebraXML: null,
                qtdCdaLoteCra: null,
                qtdDiasExibicaoAnuencia: null,
                qtdThreadsPagamentoParcelamentoDae: null,
                qtdThreadsConsultaPgto: null,
                listaValorTipoCredito: [],
                qtdediasliberadoaju: null  
            }   
        }
    },


    methods: {

        async salvar() {
            console.log(this.parametros.txtgrprotesto);

            if (this.isFieldEmpty(this.parametros.txtgrprotesto) || this.isFieldEmpty(this.parametros.txtgrajuizamento) ||     this.isFieldEmpty(this.parametros.txtgrprotestoajuizamento) ){
                
                window.scrollTo(0,0);

                this.$store.commit("setMessages", { message: 'Atenção', variant: 'danger' , errors: ['Favor preencher os campos obrigatórios (*)'] });

                return;
            }

            const urlApi = process.env.VUE_APP_ROOT_API
            const token = JSON.parse(this.$store.getters.getUser).access_token

            const parametros = {
                ...this.parametros
            }

            await axios.post(`${urlApi}/v1/parametros/salvar`, parametros, {
                    headers: {
                        'Authorization': token,
                        'Content-Type': 'application/json',
                    }
                }).then(response => {
                    if(response.data) {
                        this.$store.commit("setMessages", { message: 'Atenção', variant: 'danger' , errors: [`${response.data.message}`] });
                        window.scrollTo(0,0);
                        return
                    }
                    this.$store.commit("setMessages", { message: 'Sucesso', variant: 'success' , errors: ['Operação realizada com sucesso!!!'] });
                    window.scrollTo(0,0)
                }).catch((error) => {
                    this.exibirErro(error)
                }).finally(() => {
                    this.inSave = false
                    this.obterParametros()
                })              
        },

       
        isFieldEmpty(htmlContent) {
            if (htmlContent == null) {         
                return true; 
            }

            return  !htmlContent || htmlContent.replace(/<[^>]*>?/gm, '').trim() === ''; 
        },

       
        voltar() {
            this.$router.push({ path: '/'})
        },

        /**
         * Exibe erros dos catch
         */
        exibirErro(error) {
            this.$store.commit("setMessages", { message: 'Erro!', errors: [error] });
        },

        
        async obterParametros() {
            this.inSave = true
            const urlApi = process.env.VUE_APP_ROOT_API
            const token = JSON.parse(this.$store.getters.getUser).access_token

            axios.post(`${urlApi}/v1/parametros/obter`, {}, {
                headers: {
                    'Authorization': token,
                    'Content-Type': 'application/json'
                }
            })
            .then(response => {
                this.parametros = response.data
                this.inSave = false
            }).catch((error) => {
                this.exibirErro(error)
            })
        },
       
    },
    mounted() {
        this.$store.commit("setMessages", {});

        this.obterParametros()

    }
    
}
</script>

<style scoped>

.titulo-secao {
    border-bottom: 1px solid #CECECE; 
    font-weight: bold; 
    font-style:italic;
    padding-left: 3px;
}

</style>